import { render, staticRenderFns } from "./aiPuzzleManage.vue?vue&type=template&id=c738450e&"
import script from "./aiPuzzleManage.vue?vue&type=script&lang=js&"
export * from "./aiPuzzleManage.vue?vue&type=script&lang=js&"
import style0 from "./aiPuzzleManage.vue?vue&type=style&index=0&id=c738450e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports